
export const Theme = {
  container: [
    'px-8 py-6 border-b dark:border-gray-700',
    'dark:!border-gray-600'
  ]
};
